import { TableNotificationContract } from 'hooks/useOrderNotification/TableNotificationContract'
import { Subject } from 'rxjs'

export enum TableEventType {
    OnUpdateTableItemsCount,
}

export interface TableEventArg {
    type: TableEventType
    params: TableNotificationContract[]
}

const tableEvent = new Subject<TableEventArg>()

export default tableEvent
